import { AppDispatch } from 'src/store';
import axios from 'src/workspace/axios';
import { DEFAULT_PLAYBOOK_TRACKER_ENV_URL } from './constants';
import {
  buildPlaybookTrackerFilters,
  buildPlaybookTrackerPayload,
  transformPlaybookTrackerResponse,
} from './queries';
import { setError, setLoading, setResults } from './slice';
import { PlaybookTrackerSearchFilters } from './types';

const PLAYBOOK_ACTIONS_PROXY_URL = '/frontend/api/playbookTracker';

export const searchPlaybookActions =
  (
    filters: PlaybookTrackerSearchFilters,
    from: number = 0,
    isLoadMore: boolean = false,
  ) =>
  async (dispatch: AppDispatch, getState: any) => {
    dispatch(setLoading(true));
    dispatch(setError(null));

    try {
      const esPayload = buildPlaybookTrackerPayload(filters, from);

      const requestPayload = {
        host: filters.host || DEFAULT_PLAYBOOK_TRACKER_ENV_URL,
        params: {
          query: JSON.stringify(esPayload),
        },
      };

      const response = await axios.post(
        PLAYBOOK_ACTIONS_PROXY_URL,
        requestPayload,
        {
          withCredentials: true,
          headers: {
            'Content-Type': 'application/json',
          },
        },
      );

      const data = response.data || {};
      const newRows = transformPlaybookTrackerResponse(data);

      const existingRows = getState().playbookTracker?.rows || [];
      const updatedRows = isLoadMore ? [...existingRows, ...newRows] : newRows;

      dispatch(
        setResults({
          rows: updatedRows,
          total: data?.hits?.total?.value ?? updatedRows.length,
          filterOptions: buildPlaybookTrackerFilters(updatedRows),
        }),
      );
    } catch (error: any) {
      dispatch(
        setError(
          error?.response?.data?.message ||
            error?.message ||
            'Playbook search failed',
        ),
      );
    } finally {
      dispatch(setLoading(false));
    }
  };
